/**
 * Shared easing functions for animation progress in canvas engines.
 *
 * Originally ported from sigma.js. Graph's Camera uses `cubicOut`; scene's
 * camera/orbit transitions use `linear`, `quadraticOut`, `cubicOut`,
 * `cubicInOut`. Keep this file dependency-free so any canvas engine can
 * pick up an easing without pulling in engine-specific code.
 *
 * Source: https://github.com/jacomyal/sigma.js/blob/7b3a5ead355f7c54449002e6909a9af2eecae6db/src/utils/easings.ts
 */

export const linear = (k: number): number => k;

export const quadraticIn = (k: number): number => k * k;

export const quadraticOut = (k: number): number => k * (2 - k);

export const quadraticInOut = (k: number): number => {
  if ((k *= 2) < 1) return 0.5 * k * k;
  // oxlint-disable-next-line no-plusplus
  return -0.5 * (--k * (k - 2) - 1);
};

export const cubicIn = (k: number): number => k * k * k;

// oxlint-disable-next-line no-plusplus
export const cubicOut = (k: number): number => --k * k * k + 1;

export const cubicInOut = (k: number): number => {
  if ((k *= 2) < 1) return 0.5 * k * k * k;
  return 0.5 * ((k -= 2) * k * k + 2);
};
